import axios from "axios";
import { toast, findFieldByName } from "./notify";

const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL;
// Özel alan adı (ör. wilcopas.com): sayfa hangi adresten açıldıysa API de aynı adresten çağrılır (/api aynı sunucuya yönlenir) —
// farklı adrese gidince tarayıcı CORS/çerez nedeniyle "Network Error" veriyordu. Yapılandırılan adresle aynı host ise değişiklik yok.
const sameOriginApi = typeof window !== "undefined" && window.location.hostname !== "localhost" && new URL(CONFIGURED_URL).host !== window.location.host;
const BACKEND_URL = sameOriginApi ? window.location.origin : CONFIGURED_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Her başarılı kayıt/silme sonrası sayfalar (Taşeronlar vb.) anında yenilensin
http.interceptors.response.use((res) => {
  const m = (res.config?.method || "").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(m) && !String(res.config?.url || "").includes("/auth/")) window.dispatchEvent(new Event("data-changed"));
  return res;
});

// Geçici kesinti (sunucu yeniden başlıyor / ağ koptu / 502-503-504): GET istekleri arka planda 3 kez yeniden denenir;
// kullanıcı çalışırken ekranda hata/kopma görünmez, arka plan tazelemeleri sessizce toparlanır. Yazma istekleri tekrarlanmaz.
const TRANSIENT = new Set([502, 503, 504]);
const RETRY_WAIT = [600, 1500, 3000];
http.interceptors.response.use(undefined, async (err) => {
  const cfg = err?.config;
  // oturum sunucuda kapatıldı (yönetici) ya da süresi doldu → uygulama oturumu düşürür (giriş uçları hariç)
  if (err?.response?.status === 401 && !String(cfg?.url || "").includes("/auth/")) window.dispatchEvent(new CustomEvent("auth-expired", { detail: err.response?.data?.detail || "" }));
  if (!cfg || axios.isCancel(err) || (cfg.method || "get").toLowerCase() !== "get") throw err;
  if (err.response && !TRANSIENT.has(err.response.status)) throw err;
  const n = cfg.__retry || 0;
  if (n >= RETRY_WAIT.length) throw err;
  cfg.__retry = n + 1;
  await new Promise((r) => setTimeout(r, RETRY_WAIT[n]));
  return http(cfg);
});

const PY_MSG = { "Field required": "zorunlu alan", "Input should be a valid number": "geçerli bir sayı olmalı", "Input should be a valid integer": "tam sayı olmalı", "Input should be a valid string": "metin olmalı", "Input should be a valid date": "geçerli bir tarih olmalı", "String should have at least 1 character": "boş bırakılamaz" };
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => {
      if (!e || typeof e.msg !== "string") return JSON.stringify(e);
      const loc = Array.isArray(e.loc) ? e.loc.filter((x) => x !== "body" && x !== "query").join(".") : "";
      const m = Object.entries(PY_MSG).find(([k]) => e.msg.startsWith(k));
      return `${loc ? `${loc}: ` : ""}${m ? m[1] : e.msg}`;
    }).join(" | ");
  if (d && typeof d === "object" && typeof d.message === "string") return d.message;
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

// Hata toast'ı: detail.link → "Kayda Git"; detail.links → mesajdaki metin tıklanınca ilgili karta; 422 alan hatası → ilgili alana odak;
// aksi halde lib/notify mesajdan alan/kayıt/ekranı otomatik çözümler. ESC ile __BACK__ (mevcut ekran, aynı filtreler) adresine dönülür.
export function toastApiError(err, backUrl) {
  const d = err?.response?.data?.detail;
  const obj = d && typeof d === "object" && !Array.isArray(d) ? d : null;
  const loc = Array.isArray(d) ? d.find((e) => Array.isArray(e?.loc))?.loc : null;
  const field = loc ? findFieldByName(loc[loc.length - 1]) : null;
  return toast.error(formatApiError(err), { link: obj?.link || undefined, links: obj?.links, field: field || undefined, back: backUrl });
}

let userLabelsCache = null;
export async function getUserLabels() {
  if (!userLabelsCache) {
    userLabelsCache = await http.get("/users/lookup").then((r) => r.data).catch(() => ({}));
  }
  return userLabelsCache;
}

export function downloadUrl(path) {
  return `${API}${path}`;
}

// POST ile üretilen dosyayı (xlsx/pdf) indirir; yanıt başlıkları (ör. X-Rows) döner
export async function postDownload(path, body, filename) {
  const r = await http.post(path, body, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return r.headers || {};
}
